import React, { useContext , useEffect } from 'react';
import {useNavigate, Link } from 'react-router-dom';
import { useLocation, matchPath } from "react-router-dom";

import { AuthContext } from '../AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOut } from '@fortawesome/free-solid-svg-icons'; // Пример иконок из FontAwesome
import s from '../styles/Navbar.module.css'; // Подключение стилей



function Navbar() {
  const { role, currentUser, loading } = useContext(AuthContext); // Получаем текущее состояние пользователя 
  const location = useLocation();

  const showBackButton =
    location.pathname.startsWith("/vehicles/") ||
    location.pathname.startsWith("/adminpanel") ||
    location.pathname.startsWith("/report") ||          
    location.pathname.startsWith("/Menu") ||
    location.pathname.startsWith("/superadmin") ||       
    location.pathname.startsWith("/arhiv") ||
    location.pathname.startsWith("/add") ||
    location.pathname.startsWith("/complect");




  const navigate = useNavigate();
  
  // useEffect(() => {
  //   if (!loading && currentUser === null) {
  //     navigate("/"); // Перенаправление на главную, если пользователя нет
  //   }
  // }, [currentUser, navigate, loading]); // Зависимости: следим за изменением currentUser
  useEffect(() => {
    // Не редиректим, пока loading === true
    if (!loading) {
      // Если загрузка закончилась и user нет, уходим на /login
      if (currentUser === null) {
        navigate("/login");
      }
    }
  }, [currentUser, navigate, loading]);
  
  return (
    <nav className={s.navbar}>
        <div className={s.container}>
          <Link to="/dashboard" className={showBackButton  ? s.backButton : s.hidden}>← Назад к списку</Link> 

        {currentUser && (role === "superadmin" || role === "admin") ? (
                <div>
                    
                      <Link to="/adminpanel" title="Menu">
                      <img src="/user.svg" alt="icon" width={16} height={16} />
                      </Link>
                    
                </div>):(
                    <></>
                )}
            </div>
      {/* Правая часть с иконками */}
      <ul className={s.navbar_links}>
        {currentUser ? (
          <>
            {/* Отображаем иконки для авторизованного пользователя */}
            
            <li>
              <Link to="/Menu" title="Menu">
                <FontAwesomeIcon icon={faBars} />
              </Link>
            </li>
          </>
        ) : currentUser ? (
          <>
            {/* Отображаем иконки для неавторизованного пользователя */}
            
            <li>
              <Link to="/logout" title="Logout">
              <FontAwesomeIcon icon={faSignOut} />
              </Link>
            </li>
          </>
          ) : (
          <>
           
          </>
        )}
      </ul>
    </nav>
  );
};

const styles = {
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    border: "none",
    borderRadius: "5px",
    background: "#007bff",
    color: "white",
  }
};

export default Navbar;
